export default __webpack_public_path__ + "static/media/4_logo_orange.d9ee0f88.png";